export const NodeElements = [
    'PromoMenu',
    'InfoSection',
    'TenantSpecificComponent',
    'StaticInfoBlock',
    'ProductCatalogList',
    'DropDownMenuElementReference',
    'FooterDefinition',
    'EmptySlot',
    'FaqMarkup',
];
